(() => {
  const init = () => {
    const home = document.querySelector('.naya-home');
    const routine = home && home.querySelector('.naya-routine');
    const blackPanel = home && home.querySelector('.naya-black-panel');
    const loader = document.getElementById('bildvero-razor-feature-loader');
    if (!home || !routine || !blackPanel || !loader || document.querySelector('.naya-razor-feature')) return;

    const image = loader.dataset.image;
    if (!image) return;

    const section = document.createElement('section');
    section.className = 'naya-razor-feature';
    section.setAttribute('aria-label', 'Rasoir 2 en 1 BildVero Beauty');
    section.style.backgroundImage = `url("${image}")`;
    section.innerHTML = `
      <div class="naya-razor-feature__copy">
        <span class="naya-razor-feature__eyebrow">NOUVEAUTÉ BEAUTÉ</span>
        <span class="naya-razor-feature__pill">Rasoir 2 en 1 pour ta routine</span>
        <h2>Douceur rapide.<em>Sahl w efficace. ♡</em></h2>
        <p>Pour les retouches du quotidien, l’épilation douce w look nadi bla stress.</p>
        <div class="naya-razor-feature__benefits" aria-label="Points forts">
          <span>Doux pour la peau</span>
          <span>Pratique au quotidien</span>
          <span>Maison ou voyage</span>
        </div>
        <a class="naya-razor-feature__cta" href="#selection">Découvrir <span aria-hidden="true">→</span></a>
      </div>
      <span class="naya-razor-feature__badge">Best<br>seller</span>
      <div class="naya-razor-feature__trust" aria-label="Avantages">
        <span><b>✦</b> Livraison rapide au Maroc</span>
        <span><b>✦</b> Paiement à la livraison</span>
        <span><b>✦</b> Satisfaction garantie</span>
      </div>`;

    blackPanel.parentNode.insertBefore(section, blackPanel);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();